export const display = {
    mounted() {
        window.addEventListener('resize', this.updateDisplaySize);
        this.updateDisplaySize();

        let lastScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        const thisElem = this;
        document.addEventListener('scroll', function () {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            const scrollDifference = currentScrollPosition - lastScrollPosition;
            if (scrollDifference > 20 || scrollDifference < -20) {
                thisElem.isScrollingUp = currentScrollPosition < lastScrollPosition;
                lastScrollPosition = currentScrollPosition;
                thisElem.currentScrollTop = currentScrollPosition;
            }
        });
    },
    data() {
        return {
            clientWidth: 360,
            displayBreakpoint: 'xs',
            xsOnly: true,
            xxlAndUp: false,
            xlAndUp: false,
            lgAndUp: false,
            mdAndUp: false,
            notificationPosition: 'bottom-right',
            notificationDuration: 0,
            isScrollingUp: false,
            currentScrollTop: 0,
        };
    },
    computed: {
        tagSize() {
            return this.xsOnly ? 'small' : 'default';
        },
        inputsSize() {
            return this.xsOnly ? 'small' : 'default';
        },
        webview() {
            const standalone = window.navigator.standalone,
                userAgent = window.navigator.userAgent.toLowerCase(),
                safari = /safari/.test(userAgent),
                ios = /iphone|ipod|ipad/.test(userAgent);

            if (ios) {
                if (!standalone && safari) {
                    // Safari
                    return false;
                } else if (!standalone && !safari) {
                    // iOS webview
                    return 'ios';
                }
            } else {
                if (userAgent.includes('wv')) {
                    // Android webview
                    return 'android';
                } else {
                    // Chrome
                    return false;
                }
            }
        },
        // Check if the user is on a mobile device
        isMobileDevice() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
        }
    },
    methods: {
        updateDisplaySize() {
            const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            this.clientWidth = width;
            let size = 'xs';

            if (width >= 1920) {
                size = 'xxl';
            } else if (width >= 1400) {
                size = 'xl';
            } else if (width >= 1200) {
                size = 'lg';
            } else if (width >= 992) {
                size = 'md';
            } else if (width >= 768) {
                size = 'sm';
            } else if (width < 768) {
                size = 'xs';
            }

            this.displayBreakpoint = size;
            this.xsOnly = ['xs'].includes(size);
            this.xxlAndUp = ['xxl'].includes(size);
            this.xlAndUp = ['xxl', 'xl'].includes(size);
            this.lgAndUp = ['xxl', 'xl', 'lg'].includes(size);
            this.mdAndUp = ['xxl', 'xl', 'lg', 'md'].includes(size);
        }
    },
};
